// index.js or your entry file
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { HashRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { AuthContextProvider, UserAuth } from './Context';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from './ErrorFallback';
import { logError } from './lib/logError';
//import SearchProvider from './Context/SearchContext';
import posthog from 'posthog-js';
import { PostHogProvider} from 'posthog-js/react'

posthog.init('phc_KbtuQcVw7xJiZ57XKaoiFltxrO9ACMWI7gXOgNDsRBQ',{api_host:'https://eu.i.posthog.com', defaults:'2025-05-24'})

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
        <AuthContextProvider>
          <PostHogProvider client={posthog}>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
          </PostHogProvider>
        </AuthContextProvider>
      </ErrorBoundary>
    </Router>
  </React.StrictMode>
);